<template>
    <v-dialog :value="show" max-width="500" persistent>
        <v-card>
            <v-card-title>{{errorDetails.title}}</v-card-title>
            <v-card-text>{{errorDetails.message}}</v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn v-if="isClosable" class="primary" rounded @click.stop="closeDialog">Verstanden</v-btn>
                <v-spacer/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ErrorDialog',
    props: {
        value: {
            type: Boolean
        },
        errorDetails: {
            type: Object,
            default: function()
            {
                return {
                    title: 'Fehler',
                    message: 'Es ist ein Fehler aufgetreten. Bitte versuchs nochmal!'
                };
            }
        },
        isClosable: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        closeDialog()
        {
            this.show = false;
        }
    }
}
</script>

<style scoped>

</style>